module.exports = __webpack_public_path__ + "img/share.14dd1bde.png";